import { createSlice } from "@reduxjs/toolkit"
import {
  getAllSalesReports,
  getBusinessTaxReports,
  getLoyaltyPointsReports,
  getPaymentMethodReports,
  getGiftcardReports,
  getWalletdReports,
} from "store/actions/reportsAction"

const initialState = {
  loading: true,
  isLoading: false,
  itemsPerPage: 10,
  totalPages: null,
  totalCount: null,
  currentPage: 1,
  salesReports: [],
  paymentsMethodReports: [],
  businessTaxReports: [],
  loyaltyPointsReports: [],
  giftcardReports:[],
  walletReport:[],

}

const usersSlice = createSlice({
  name: "countries",
  initialState,
  reducers: {},
  extraReducers: builder => {
    // GET ALL SALES REPORTS
    builder
      .addCase(getAllSalesReports.pending, state => {
        state.loading = true
        state.totalCount = null
        state.totalPages = null
        state.currentPage = null
      })
      .addCase(getAllSalesReports.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          const { totalCount, totalPages, currentPage } = action.payload
          state.salesReports = data
          state.totalCount = totalCount
          state.totalPages = totalPages
          state.currentPage = currentPage
        }
      })
      .addCase(getAllSalesReports.rejected, (state, action) => {
        state.loading = false
      })
  // GET GIFT CARD REPORTS
  builder
  .addCase(getGiftcardReports.pending, state => {
    state.loading = true
    state.totalCount =  null
    state.totalPages = null
    state.currentPage = null
  })
  .addCase(getGiftcardReports.fulfilled, (state, action) => {
    state.loading = false
    const { status, data } = action.payload
    if (status) {
      const { totalCount, totalPages, currentPage } = action.payload
      state.giftcardReports = data
      state.totalCount = totalCount
      state.totalPages = totalPages
      state.currentPage = currentPage
    }
  })

  .addCase(getGiftcardReports.rejected, (state,action)=>{
    state.loading = false
  })

  // WALLET REPORT
  builder
  .addCase(getWalletdReports.pending, state => {
    state.loading = true
    state.totalCount =  null
    state.totalPages = null
    state.currentPage = null
  })
  .addCase(getWalletdReports.fulfilled, (state, action) => {
    state.loading = false
    const { status, data } = action.payload
    if (status) {
      const { totalCount, totalPages, currentPage } = action.payload
      state.walletReport = data
      state.totalCount = totalCount
      state.totalPages = totalPages
      state.currentPage = currentPage
    }
  })

  .addCase(getWalletdReports.rejected, (state,action)=>{
    state.loading = false
  })
    // GET PAYMENTS METHOD REPORTS
    builder
      .addCase(getPaymentMethodReports.pending, state => {
        state.loading = true
        state.totalCount = null
        state.totalPages = null
        state.currentPage = null
      })
      .addCase(getPaymentMethodReports.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          const { totalCount, totalPages, currentPage } = action.payload
          state.paymentsMethodReports = data
          state.totalCount = totalCount
          state.totalPages = totalPages
          state.currentPage = currentPage
        }
      })
      .addCase(getPaymentMethodReports.rejected, (state, action) => {
        state.loading = false
      })

    // GET BUSINESS TAX REPORTS
    builder
      .addCase(getBusinessTaxReports.pending, state => {
        state.loading = true
        state.totalCount = null
        state.totalPages = null
        state.currentPage = null
      })
      .addCase(getBusinessTaxReports.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          const { totalCount, totalPages, currentPage } = action.payload
          state.businessTaxReports = data
          state.totalCount = totalCount
          state.totalPages = totalPages
          state.currentPage = currentPage
        }
      })
      .addCase(getBusinessTaxReports.rejected, (state, action) => {
        state.loading = false
      })

    // GET LOYALTY POINTS REPORTS
    builder
      .addCase(getLoyaltyPointsReports.pending, state => {
        state.loading = true
        state.totalCount = null
        state.totalPages = null
        state.currentPage = null
        state.loyaltyPointsReports = []
      })
      .addCase(getLoyaltyPointsReports.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          const { totalCount, totalPages, currentPage } = action.payload
          state.loyaltyPointsReports = data
          state.totalCount = totalCount
          state.totalPages = totalPages
          state.currentPage = currentPage
        }
      })
      .addCase(getLoyaltyPointsReports.rejected, (state, action) => {
        state.loading = false
      })
  },
})

export default usersSlice.reducer
